import React, { createContext, useContext, useState, useCallback } from "react";

const TooltipContext = createContext();

export const TooltipProvider = ({ children }) => {
  const [targets, setTargets] = useState({});

  const registerRef = useCallback((key, ref) => {
    if (!key || !ref) return; // Avoid unnecessary updates
    setTargets((prev) => {
      if (prev[key] === ref) return prev; // Prevent re-renders if ref didn't change
      return { ...prev, [key]: ref };
    });
  }, []);

  return (
    <TooltipContext.Provider value={{ targets, registerRef }}>
      {children}
    </TooltipContext.Provider>
  );
};

export const useTooltip = () => {
  const context = useContext(TooltipContext);
  if (!context) {
    throw new Error("useTooltip must be used within a TooltipProvider");
  }
  return context;
};
